import * as Yup from 'yup'

export const CustomerOnboardingBusinessDetailsSchema = Yup.object().shape({
  doesBusinessAdvertise: Yup.string().required('This field is required'),
  hasQualityProgram: Yup.string().required('This field is required'),
  qualityProgramDetails: Yup.string(),
  vehicleAccessDetails: Yup.string(),
  coveredCitiesDetails: Yup.string(),
})
